import { accessor, identifier, literal } from '@tectonic/halo-script';

const access = ([head, ...tail]: [string, ...(string | number | boolean)[]]) =>
  accessor([identifier(head), ...tail.map((item) => literal(item))]);

export { access };
